import { skipToken } from "@reduxjs/toolkit/dist/query";
import { useMemo } from "react";
import { useListSourcingEventsForBuyerQuery } from "../../../autogen/bff-api";
import { useSub } from "../../subscription/useSub";
import type { NavBadgeKey } from "./navConfig";
import { countBadgesByStatus } from "./statusBuckets";

export type NavBadges = Partial<Record<NavBadgeKey, number>>;

/**
 * Real count badges for the sidebar's procurement-status items, derived from the buyer's
 * V2 sourcing events grouped by status via the exhaustive STATUS_BUCKET map. The needs
 * (behov*) buckets have no backend yet and stay absent. Only queries when the org has V2
 * sourcing-event access.
 */
export const useNavBadges = (): NavBadges => {
  const sub = useSub();
  const { data } = useListSourcingEventsForBuyerQuery(sub.hasSourcingEventV2Access ? {} : skipToken);

  return useMemo(() => countBadgesByStatus(data?.events ?? []), [data]);
};
